import { fetchClientnameFrompassport } from "./fetchClientnameFrompassport";
export const factClientCheck = async (updatedRows, setNotification, setErrorPassport) => {
    const notifications = [];
    const errormsg = [];
    for (let index = 0; index < updatedRows.length; index++) {
        const passportValue = updatedRows[index].passport;
        const clientNameValue = updatedRows[index].clientName;
        if (passportValue) {
            if (passportValue.length < 9 && passportValue.length > 5 && !clientNameValue) {
                const clientName = await fetchClientnameFrompassport(passportValue, (msg) => {
                    if (msg) notifications.push({ index, message: `${index + 1}: ${msg}` });
                });
                updatedRows[index].clientName = clientName;
            } else if (passportValue.length < 6 && passportValue.length >= 1) {
                updatedRows[index].clientName = '';
                errormsg.push({
                    index,
                    message: `${index + 1}: رقم جواز السفر ${passportValue} يجب ان يكون من 6 او 7 او 8 احرف.`,
                });
            }else{
                notifications.push({ 
                    index,
                    message: '',
                });
                errormsg.push({ 
                    index,
                    message: '',
                });
            }
        }
    }
    const filteredNotifications = notifications.filter(
        (notification) => {
            const row = updatedRows[notification.index];
            return !(row.passport && row.clientName); 
        }
    );

    const filterederrors = errormsg.filter(
        (error) => {
            const row = updatedRows[error.index];
            return !(row.passport && row.clientName); 
        }
    );
    setNotification(filteredNotifications.map((n) => n.message).join('\n'));
    setErrorPassport(filterederrors.map((n) => n.message).join('\n'));
};



